import {announce} from '@github-ui/aria-live'
import {CheckIcon, CopyIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useEffect, useRef, useState} from 'react'
import {copyRichText} from '../helpers/copy-rich-text'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {buildPullRequestLink} from '../helpers/build-pull-request-link'

const copyConfirmationMsDelay = 2000

export function PullRequestCopyLinkButton({
  owner,
  repository,
  number,
  titleHtml,
}: {
  owner: string
  repository: string
  number: number
  titleHtml: SafeHTMLString
}) {
  const [copied, setCopied] = useState(false)
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => {
    return () => clearTimeout(timeoutIdRef.current)
  }, [])

  const handleCopy = () => {
    const url = new URL(`/${owner}/${repository}/pull/${number}`, window.location.origin).href
    const link = buildPullRequestLink({url, owner, repository, number, titleHtml})

    setCopied(true)
    void copyRichText({html: link.outerHTML, plainText: url})
    announce('Copied!')
    clearTimeout(timeoutIdRef.current)
    timeoutIdRef.current = setTimeout(() => setCopied(false), copyConfirmationMsDelay)
  }

  return (
    <IconButton
      aria-label="Copy link"
      className={copied ? 'color-fg-success' : undefined}
      icon={copied ? CheckIcon : CopyIcon}
      onClick={handleCopy}
      size="small"
      variant="invisible"
    />
  )
}
